import { appInfo } from '@/mocks/homepage';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-12 md:py-16 bg-gradient-to-br from-background-900 to-background-800">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-3">
              {appInfo.title}
            </h2>
            <p className="text-sm md:text-base text-background-300 mb-6">
              {appInfo.subtitle}
            </p>
            <ul className="space-y-3 mb-7">
              {appInfo.features.map((feat, idx) => (
                <li key={idx} className="flex items-center gap-3 justify-center lg:justify-start">
                  <div className="w-6 h-6 rounded-full bg-primary-500/30 flex items-center justify-center shrink-0">
                    <i className="ri-check-line text-primary-400 text-sm"></i>
                  </div>
                  <span className="text-sm text-background-200">{feat}</span>
                </li>
              ))}
            </ul>
            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
              <button className="px-8 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill mr-2"></i>
                App Store 下载
              </button>
              <button className="px-8 py-3 bg-background-700 text-background-200 font-semibold text-sm rounded-lg hover:bg-background-600 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-fill mr-2"></i>
                安卓版下载
              </button>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="w-52 h-52 md:w-60 md:h-60 rounded-2xl bg-background-50 p-3">
              <img
                src={appInfo.qrImage}
                alt="91视频APP下载"
                className="w-full h-full object-cover rounded-xl"
              />
            </div>
            <p className="text-xs text-background-400 text-center mt-3">扫码下载91视频APP</p>
          </div>
        </div>
      </div>
    </section>
  );
}